
/**
 * Formats a phone number by removing non-numeric characters and ensuring it has the country code
 * @param phoneNumber The phone number to format
 * @returns The formatted phone number with country code
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  // Remove all non-numeric characters
  const numericOnly = phoneNumber.replace(/\D/g, '');
  
  // If the number doesn't start with the country code, add Brazil's code (+55)
  if (!numericOnly.startsWith('55')) {
    return `55${numericOnly}`;
  }
  
  return numericOnly;
};
